require('./brokerTransferPensionPlansExternal.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const { FormattedText, formatText } = require('core/i18n').i18n;

// @commons
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const WizardError = require('components/commons/wizardError/wizardError');
const OKModal = require('components/commons/OKModal/OKModal');

// @Components
const BrokerTransferPensionPlansExternalStep1 = require('./brokerTransferPensionPlansExternalStep1/brokerTransferPensionPlansExternalStep1');
const BrokerTransferPensionPlansExternalStep2 = require('./brokerTransferPensionPlansExternalStep2/brokerTransferPensionPlansExternalStep2');
const BrokerTransferPensionPlansExternalStep3 = require('./brokerTransferPensionPlansExternalStep3/brokerTransferPensionPlansExternalStep3');
const BrokerTransferPensionPlansExternalStep4 = require('./brokerTransferPensionPlansExternalStep4/brokerTransferPensionPlansExternalStep4');
const BrokerTransferPensionPlansExternalSuccess = require('./brokerTransferPensionPlansExternalSuccess/brokerTransferPensionPlansExternalSuccess');
const BrokerInvestmentSpecialistModal = require('components/broker/brokerInvestmentSpecialistModal/brokerInvestmentSpecialistModal');
//@ utilities
const PersonalDataHelper = require('utilities/personalDataHelper');
// @Constants
const {
    BROKER_TRANSFER_PENSION_PLAN_STEP_1,
    BROKER_TRANSFER_PENSION_PLAN_STEP_2,
    BROKER_TRANSFER_PENSION_PLAN_STEP_3,
    BROKER_TRANSFER_PENSION_PLAN_STEP_4,
    BROKER_CALLMEBACK_VALID_TEL_CODE_REG_EX,
    PHONE_AND_MOBILE_NUMBER_REGEX
} = require('constants/index');

class BrokerTransferPensionPlansExternal extends React.Component {

    constructor(props){
        super(props)
        const telephone = PersonalDataHelper.getPhoneOnly(props.immProfile);
        const telCode = PersonalDataHelper.getPhoneCodeOnly(props.immProfile);
        this.state = {
            showModal: false,
            showErrorMessagesModal: false,
            telephone,
            telCode,
            callTime: '',
            telephoneError: false,
            telephoneCodeError: false
        }
        this.handleErrorClick = this.handleErrorClick.bind(this);
        this.handleRequestCall = this.handleRequestCall.bind(this);
        this.validateFields = this.validateFields.bind(this);
        this.onTelCodeChange = this.onTelCodeChange.bind(this);
        this.onTelChange = this.onTelChange.bind(this);
        this.handleContactModalToggle = this.handleContactModalToggle.bind(this);
    }

    componentDidMount() {
        this.props.onReset();
        this.props.getSpecialists();
    }
    
    handleContactModalToggle(){
        this.setState({
            showModal: !this.state.showModal
        });
        this.props.onToggleModal();
    }

    handleRequestCall(){
        const valid = this.validateFields();

        if (valid) {
            this.props.onRequestCall();
            this.handleContactModalToggle();
            this.setState({
                showErrorMessagesModal: false
            });
        } else {
            this.setState({
                showErrorMessagesModal: true
            });
        }
    }

    onTelChange(value) {
        this.setState({telephone: value});
        this.props.onTelChange(value);
    }

    onTelCodeChange(value) {
        this.setState({telCode: value});
        this.props.onTelCodeChange(value);
    }

    validateFields() {
            const { telephone, telCode } = this.state;
            const profileTelephone = PersonalDataHelper.getPhoneOnly(this.props.immProfile);
            const phoneDirty = !(profileTelephone === telephone);
            const validTelCode = BROKER_CALLMEBACK_VALID_TEL_CODE_REG_EX.test(telCode);
            let validTelNumber = telephone && telephone.length;
            const countryCode = PersonalDataHelper.getPhoneCodeFromOriginCountry(this.props.immProfile.get('originCountry'))
            if (validTelNumber && telCode === `+${countryCode}` && phoneDirty) {
                 validTelNumber = PHONE_AND_MOBILE_NUMBER_REGEX.test(telephone);
            }
    
            this.setState({telephoneError: !validTelNumber, telephoneCodeError: !validTelCode});
    
            return validTelNumber && validTelCode;
        }

    buildWizard() {
        const { 
            immPlans,
            immAccounts,
            immBrokerTransferPensionPlansExternal,
            immProfile,
            handleAmountChange,
            handleAttachFile,
            handleChangeDestinationOption,
            handleChangeTransferTypeOption,
            handleChangeFiscalizationOption,
            handleDestinationPlanChange,
            handleDestinationPlans,
            handleAccountChange,
            handleRemoveFile,
            handleSetDescription,
            onCancel,
            onFinish,
            setAmountRange,
            setVisibleStep,
            setWillCancel,
            toggleDisclaimer,
            validateStep,
            handleInputSearchPlanSelected
        } = this.props;
        const wizardClass = 'broker-transfer-pension-plans-external__wizard';
        const immSteps = immBrokerTransferPensionPlansExternal.get('steps');
        const visibleStep = immBrokerTransferPensionPlansExternal.get('visibleStep');
        const stepsAmount=immBrokerTransferPensionPlansExternal.get('steps').size;
        const immFinalButton = "brokerTraspassBetweenMyPlans-brokerTraspassBetweenMyPlans_step4Traspass"
        const immStep1 = immBrokerTransferPensionPlansExternal.get('steps')
            .get(BROKER_TRANSFER_PENSION_PLAN_STEP_1);
        const immStep2 = immBrokerTransferPensionPlansExternal.get('steps')
            .get(BROKER_TRANSFER_PENSION_PLAN_STEP_2);
        const immStep3 = immBrokerTransferPensionPlansExternal.get('steps')
            .get(BROKER_TRANSFER_PENSION_PLAN_STEP_3);
        const immStep4 = immBrokerTransferPensionPlansExternal.get('steps')
            .get(BROKER_TRANSFER_PENSION_PLAN_STEP_4);
        const actions = {
            validateStep,
            setVisibleStep,
            setWillCancel,
            cancel: onCancel,
            finish: onFinish
        };
        const walletPlans = immBrokerTransferPensionPlansExternal.get('walletPlansData');

        return (
            <div className="broker-transfer-pension-plans-external__wizard">
                <Wizard
                    wizardClass={wizardClass}
                    actions={actions}
                    stepsAmount={stepsAmount}
                    visibleStep={visibleStep}
                    immSteps={immSteps}
                >
                    <WizardStep
                        position="first"
                        cancelButton={true}
                        nextButton={true}
                        nextButtonDisabled={!immStep1.get('success')}
                        isLoading={immStep1.get('isFetching')}
                    >
                        <BrokerTransferPensionPlansExternalStep1
                            immStep={immStep1} 
                            handlePlanSelectFromSearch={handleInputSearchPlanSelected}
                            addFile={handleAttachFile}
                            walletPlans={walletPlans} 
                            removeFile={handleRemoveFile}
                            setDescription={handleSetDescription}
                        />   
                    </WizardStep>
                    <WizardStep
                        position="middle"
                        cancelButton={true}
                        nextButton={true}
                        nextButtonDisabled={!immStep2.get('success')}
                        isLoading={immStep2.get('isFetching')}
                    >
                        <BrokerTransferPensionPlansExternalStep2
                            immStep1={immStep1}
                            immStep={immStep2}
                            immPlans={immPlans} 
                            immAccounts={immAccounts}
                            onSelectPlan={handleDestinationPlanChange}
                            onAccountChange={handleAccountChange}
                            onChangeDestinationOption={handleChangeDestinationOption}
                            walletPlans={walletPlans}
                            handleDestinationPlans={handleDestinationPlans}
                            handlePlanSelectFromSearch={handleInputSearchPlanSelected}/>
                    </WizardStep>
                    <WizardStep
                        position="middle"
                        cancelButton={true}
                        nextButton={true}
                    >
                        <BrokerTransferPensionPlansExternalStep3 
                            immStep={immStep3}
                            handleAmountChange={handleAmountChange}
                            handleChangeTransferTypeOption={handleChangeTransferTypeOption}
                            handleChangeFiscalizationOption={handleChangeFiscalizationOption}
                            setAmountRange={setAmountRange}/>
                    </WizardStep>
                    <WizardStep
                        addLoadingBehaviour={true}
                        position="last"
                        cancelButton={true}
                        finishButton={true}
                        finalButtonDisabled={!immStep4.get('valid')}
                        immFinalButton={immFinalButton}
                    >
                        <BrokerTransferPensionPlansExternalStep4 
                            immProfile={immProfile}
                            immStep1={immStep1}
                            immStep2={immStep2}
                            immStep3={immStep3}
                            immStep4={immStep4}
                            toggleDisclaimer={toggleDisclaimer}/>
                    </WizardStep>
                </Wizard>
            </div>
        )
    }

    buildSuccess() {
        const { immBrokerTransferPensionPlansExternal } = this.props;

        return (
            <div className="broker-transfer-pension-plans-external__success">
                <BrokerTransferPensionPlansExternalSuccess 
                    immBrokerTransferPensionPlansExternal={immBrokerTransferPensionPlansExternal}
                />
            </div>
        )
    }

    handleErrorClick(){
       this.setState({showModal:true});
    }

    buildError(){
        const { immInvestmentSpecialists, 
            immBrokerTransferPensionPlansExternal,
            immProfile,
            onTelCodeChange,
            onTelChange,
            onCallTimeChange,
            onCommentChange,
            onRequestBrokerCallTimeOptions,
            onSetProfilePhone
        } = this.props;
        const {showModal} = this.state;
        const errorTitle = <FormattedText value="broker-errorTitle"/>;
        const errorMessage = <FormattedText value={immBrokerTransferPensionPlansExternal.get('errorMsgKey')} />
        const myWalletLink = `/myprofile/broker`;
        const mainButton = {
            label: <FormattedText value="broker-broker_contact" />,
        }
        const secondaryButton = {
            label: <FormattedText value="broker-backToMyWallet" />,
            url: myWalletLink
        }

        const contentModal = (
            <BrokerInvestmentSpecialistModal
                immInvestmentSpecialists={immInvestmentSpecialists}
                immProfile={immProfile}
                onTelCodeChange={onTelCodeChange}
                onTelChange={onTelChange}
                onCallTimeChange={onCallTimeChange}
                onCommentChange={onCommentChange}
                onCloseClick={this.handleContactModalToggle}
                onRequestCall={this.handleRequestCall}
                onRequestBrokerCallTimeOptions={onRequestBrokerCallTimeOptions}
                onSetProfilePhone={onSetProfilePhone}
                showErrorMessages={this.state.showErrorMessagesModal}
            />
        );

        return (
            <div className="broker-transfer-pension-plans-external__error">
                <WizardError
                    errorMessage={errorTitle}
                    mainButton={mainButton}
                    onMainButtonClick={this.handleErrorClick}
                    secondaryButton={secondaryButton}
                >
                    <OKModal
                        extraClass="broker-transfer-pension-plans-external"
                        content={contentModal}
                        footerType="navigation"
                        isOpen={showModal}
                        onCloseCallback={this.handleContactModalToggle}
                        onPrimaryButtonClick={this.handleRequestCall}
                        onSecondaryButtonClick={this.handleContactModalToggle}
                        primaryButtonText="brokerInvestmentSpecialistModal-request"
                        primaryButtonLoading={immInvestmentSpecialists.get('requestingCall')}
                        secondaryButtonText="brokerInvestmentSpecialistModal-cancel"
                    />
                    <div>
                        <div className="broker-errors-view__primary-message">
                            {errorMessage}
                        </div>
                        <div>
                            <FormattedText
                                value="broker-errorSecondaryMessage"
                                injectedStrings={[formatText('emails-investments')]}
                            />
                        </div>
                    </div>
                </WizardError>
            </div>
        );
    }

    buildBody() {
        const { immBrokerTransferPensionPlansExternal, brokerError } = this.props;
        let content;
        const immStep4 = immBrokerTransferPensionPlansExternal.get('steps').get(BROKER_TRANSFER_PENSION_PLAN_STEP_4);
        if (immBrokerTransferPensionPlansExternal.get('error') || brokerError){
            content = this.buildError();
        }
        else {
            if(immStep4.get('success') && immBrokerTransferPensionPlansExternal.get('submitSuccessful')) {
                content = this.buildSuccess();
            } else {
                content = this.buildWizard();
            }
        }
        

        return content;
    }

    render() {
        
        return (
            <div>
                {this.buildBody()}
            </div>
        );
    }
}

BrokerTransferPensionPlansExternal.propTypes = {
    brokerError: PropTypes.bool.isRequired,
    handleAmountChange: PropTypes.func.isRequired,
    handleAttachFile: PropTypes.func.isRequired,
    handleDestinationPlans: PropTypes.func.isRequired,
    handleChangeTransferTypeOption: PropTypes.func.isRequired,
    handleChangeFiscalizationOption: PropTypes.func.isRequired,
    handleChangeDestinationOption: PropTypes.func.isRequired,
    handleDestinationPlanChange: PropTypes.func.isRequired,
    handleOriginPlanChange: PropTypes.func.isRequired,
    handlePlanSelectFromSearch:PropTypes.func,
    handleRemoveFile: PropTypes.func.isRequired,
    handleAccountChange: PropTypes.func.isRequired,
    handleSetDescription: PropTypes.func.isRequired,
    immPlans: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immBrokerTransferPensionPlansExternal: PropTypes.object.isRequired,
    immInvestmentSpecialists: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    immSignaturePattern: PropTypes.object.isRequired,
    onCancel: PropTypes.func.isRequired,
    onCallTimeChange: PropTypes.func.isRequired,
    onCommentChange: PropTypes.func.isRequired,
    onFinish: PropTypes.func.isRequired,
    onRequestCall: PropTypes.func.isRequired,
    onRequestBrokerCallTimeOptions: PropTypes.func.isRequired,
    onToggleModal: PropTypes.func.isRequired,
    getSpecialists: PropTypes.func.isRequired,
    onSetProfilePhone: PropTypes.func.isRequired,
    onReset: PropTypes.func.isRequired,
    onTelCodeChange: PropTypes.func.isRequired,
    onTelChange: PropTypes.func.isRequired,
    setAmountRange: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    toggleDisclaimer: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    handleInputSearchPlanSelected: PropTypes.func.isRequired
};
 
module.exports = BrokerTransferPensionPlansExternal;

